/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { CONTRACTS_FETCH_REQUEST, success, failure } from './action';

const fetchContracts = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(CONTRACTS_FETCH_REQUEST)
    .map(({ payload: { params } }) => params)
    .mergeMap((params) =>
      AjaxRequest.open(
        'get',
        `/admin/contractcustom/contracts?${params.toString()}`,
      )('tudo')
        .flatMap((data) => Observable.of(success(data.response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(fetchContracts);
